import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Card } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#0D1117",
        textAlign: "center",
      }}
    >
      <Card
        sx={{
          padding: 4,
          backgroundColor: "#161B22",
          borderRadius: 2,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
          maxWidth: 400,
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 60, color: "#FF6B6B", marginBottom: 2 }} />
        <Typography variant="h5" sx={{ color: "#FFFFFF", fontWeight: "bold", marginBottom: 1 }}>
          Unauthorized Access
        </Typography>
        <Typography variant="body1" sx={{ color: "#A8B2D1", marginBottom: 3 }}>
          You do not have permission to view this page.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#1F6FEB",
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#2C8AFF" },
          }}
          onClick={() => navigate("/login")}
        >
          Go to Login
        </Button>
      </Card>
    </Box>
  );
};

export default Unauthorized;
